import parlays from './parlays.jpeg'
import countyShifts from './county_shifts.png'
import recipes from './recipes.jpeg'
import fecFood from './fec_food.png'
import swingStateGuide from './swing_state_guide.png'
import polls from './post_polls.png'
import gymnastics from './gymnastics.jpeg'
import smallTowns from './small_towns.jpeg'
import lego from './lego.jpeg'
import majority from './majority.jpeg'
import adrift from './adrift.png'
import gaza from './gaza.png'
import polarBears from './polar_bears.png'
import fedGovCuts from './fed_gov_cuts.jpeg'

export const imgKey = {
    fedGovCuts,
    parlays,
    countyShifts,
    recipes,
    fecFood,
    swingStateGuide,
    polls,
    gymnastics,
    smallTowns,
    lego,
    majority,
    adrift,
    gaza,
    polarBears
}